import { useEffect, useMemo } from 'react';

import { PagesUrl } from 'core/Utils';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';

const Redirect = ({ to = '' }: { to?: string }) => {
  useEffect(() => {
    window.location.href = 'https://www.givebacks.com' + to;
  }, [to]);

  return <></>;
};

const RedirectNativeOnboarding = () => {
  // /give is already flagged to be redirected to /causes
  return <Navigate to="/give" replace />;
};

const CausePageRedirect = () => {
  const { uuid } = useParams();
  return <Navigate to={`/causes/${uuid}`} replace />;
};
const CauseDeepPageRedirect = () => {
  const { uuid } = useParams();
  const { pathname } = useLocation();

  const pathAfterCauseId = useMemo(() => pathname.split(uuid ?? '')[1], [pathname, uuid]);

  return <Navigate to={`/causes/${uuid}${pathAfterCauseId}`} replace />;
};
const MobileWebRedirect = () => {
  return (
    <Routes>
      <Route path=":uuid" element={<CausePageRedirect />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

const OnboardingRedirect = () => {
  return (
    <Routes>
      <Route path="causes/:uuid" element={<CausePageRedirect />} />
      <Route path="causes/:uuid/*" element={<CauseDeepPageRedirect />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

const Redirects = () => {
  return (
    <Routes>
      <Route path="/do-not-sell" element={<Redirect to={PagesUrl.DO_NOT_SELL} />} />
      <Route path="/cashback-faq" element={<Redirect to={'/faq'} />} />
      <Route path="/general-faqs" element={<Redirect to={'/faq'} />} />
      <Route path="/aboutus" element={<Redirect to={PagesUrl.ABOUT_US} />} />
      <Route path="/privacy-policy" element={<Redirect to={PagesUrl.PRIVACY_POLICY} />} />
      <Route path={'/terms-of-service'} element={<Redirect to={PagesUrl.TERMS_of_SERVICE} />} />
      <Route path="/sign_in" element={<Navigate to="/sign-in" replace />} />
      <Route path="signup" element={<Navigate to="/sign-up" replace />} />
      <Route path="/add-card" element={<Navigate to="/home" replace />} />
      {/* TODO: Remove 09/09/25 */}
      <Route path="/native/*" element={<RedirectNativeOnboarding />} />
      {/* TODO: Remove 09/09/25 */}
      <Route path="/mobile/web/*" element={<MobileWebRedirect />} />
      {/* TODO: Remove 09/09/25 */}
      <Route path="/onboarding/*" element={<OnboardingRedirect />} />
      {/* 
      TODO: Remove the /give native app redirect once the native app is updated to redirect to /causes
      
      */}
      {/* TODO: Remove 09/09/25 */}
      <Route path="/c/categories/:uuid" element={<Navigate to="/sign-up" replace />} />
      <Route path="give/*" element={<Navigate to={'/causes'} replace />} />
      <Route path="/offers/*" element={<Navigate to="/earn" replace />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

export { Redirects };
